import { Fragment } from "react";
import { Link, useLocation, useMatches } from "remix";
import { useIsLoggedIn, useUsername } from "~/utils/useIsLoggedIn";

export function Footer() {
  const isLoggedIn = useIsLoggedIn();
  const username = useUsername();
  const additionalFooterContent = useMatches()
    .filter((match) => !!match.handle?.footer)
    .map((match, index) => (
      <Fragment key={index}>{match.handle.footer(match)}</Fragment>
    ));

  const { pathname: redirectTo } = useLocation();

  return (
    <footer className="main-layout-centered py-10 bg-white border-t border-t-gray-200">
      {additionalFooterContent.length > 0 && additionalFooterContent}
      <div className="flex flex-col md:flex-row items-center justify-center">
        <Link className="text-gray-500 hover:underline m-2" to="/archive">
          Archiv
        </Link>
        <Link className="text-gray-500 hover:underline m-2" to="/about">
          Über uns
        </Link>
        <Link className="text-gray-500 hover:underline m-2" to="/impressum">
          Impressum
        </Link>
        <Link className="text-gray-500 hover:underline m-2" to="/datenschutz">
          Datenschutz
        </Link>
      </div>
      <div className="flex flex-col md:flex-row items-center justify-center">
        {isLoggedIn ? (
          <>
            <Link className="text-gray-500 hover:underline m-2" to="/admin">
              Admin
            </Link>
            <span className="text-gray-500 m-2">(signed in as {username})</span>
            <form
              action="/logout"
              method="post"
              className="inline-block text-gray-500 hover:underline m-2"
            >
              <button type="submit">Logout</button>
            </form>
          </>
        ) : (
          <Link
            className="text-gray-500 m-2"
            to={`/login?redirectTo=${redirectTo}`}
          >
            Login
          </Link>
        )}
      </div>
    </footer>
  );
}
